import { tAgendaActionContext } from './Agenda.types';

export const initialState: tAgendaActionContext = {
  templates: [],
  onCreateChatEventSubmit: () => {},
};
